module.exports = "https://s.pinimg.com/webapp/style/images/closeupImage-c3c6ddf3.png";